// Parallax simple y autónomo para la segunda imagen cuando hay overlap
(function(){
  function update(){
    var wraps = document.querySelectorAll('.iwt-image-wrap[data-enable-parallax="true"] .iwt-second');
    var wh = window.innerHeight || 0;
    for (var i = 0; i < wraps.length; i++){
      var el = wraps[i];
      var rect = el.getBoundingClientRect();
      var visible = rect.top < wh && rect.bottom > 0;
      if(!visible) continue;
      var center = (rect.top + rect.bottom) / 2;
      var delta = (center - wh/2) / (wh/2); // -1..1
      var strength = 12; // px de desplazamiento
      el.style.transform = 'translateY(' + (delta * strength) + 'px)';
    }
  }
  var ticking = false;
  function onScroll(){ if(!ticking){ ticking = true; requestAnimationFrame(function(){ ticking = false; update(); }); } }
  window.addEventListener('scroll', onScroll, { passive:true });
  window.addEventListener('resize', onScroll);
  document.addEventListener('DOMContentLoaded', onScroll);
})();
